import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import publicIp from "react-public-ip";

import api from "../../services/api";
import ender from "../../tools/ender";
import { acesso } from "../../tools/SAP";

import "./styles.css";

export default function Consulta({ history, location }) {
  const [audiencia, setAudiencia] = useState([]);
  const [arquivos, setArquivos] = useState([]);
  const [resultados, setResultados] = useState([]);
  const [estatisticas, setEstatisticas] = useState([]);
  const [ipv4,setIpv4] = useState("");
  const { consulta_id } = useParams();
  const [idAudiencia] = useState(consulta_id);
  const [usuarioANA] = useState(localStorage.getItem("ANA"));

  useEffect(() =>
  {
    async function retornaIP(){
      setIpv4(await publicIp.v4() || "");
    }
    retornaIP();
  }, [idAudiencia]);

  if (ipv4){
    acesso(ipv4,location.pathname,idAudiencia);
  }

  useEffect(() => {
    async function loadAudiencia() {
      if (!isNaN(idAudiencia)) {
        const response = await api.get(`/api/audiencia/${idAudiencia}`);
        setAudiencia(response.data[0]);
      }
    }
    loadAudiencia();
  }, [idAudiencia]);

  useEffect(() => {
    async function loadArquivos() {
      if (!isNaN(audiencia.ID_AUDIENCIA)) {
        const response = await api.get(
          `/api/audiencia/arquivos/${audiencia.ID_AUDIENCIA}`
        );
        setArquivos(response.data);
      }
    }
    loadArquivos();
  }, [audiencia]);

  useEffect(() => {
    async function loadResultados() {
      if (!isNaN(audiencia.ID_AUDIENCIA)) {
        const response = await api.get(
          `/api/audiencia/${audiencia.ID_AUDIENCIA}/rac`
        );
        setResultados(response.data);
      }
    }
    loadResultados();
  }, [audiencia]);

  useEffect(() => {
    async function loadEstatisticas() {
      const response = await api.get(`/api/estatisticas/${idAudiencia}`, {});
      setEstatisticas(response.data);
    }
    loadEstatisticas();
  }, [idAudiencia]);

  function handleClickListarContribuicoes(idAudiencia) {
    history.push(`/Consulta/${idAudiencia}/Contribuicoes`);
  }

  function handleClickContribuir(idAudiencia) {
    localStorage.setItem("idAudiencia", idAudiencia);
    if (localStorage.getItem("Email")){
      history.push(`/Consulta/${consulta_id}/Contribuicao/`);
    } else {
      history.push(`/Login`);
    }
  }

  return (
    <>
      <Container>
        <Row>
          <Col sm={12}>
            <div className="voltar">
              <a href="/">voltar</a>
            </div>
          </Col>
        </Row>
        <div className="quadro">
          <Row>
            <Col sm={12}>
              <h2>
                {audiencia.DS_MODALIDADE + " nº "}
                {audiencia.NU_AUDIENCIA} / {audiencia.DT_ANO_AUDIENCIA}
              </h2>
            </Col>
          </Row>
          <Row>
            <Col sm={12} className={
                            audiencia.ST_ENCERRADO === "P" ? "aberto" : audiencia.ST_ENCERRADO === "S" ? "fechado" : "futuro"}>
                  {`Período de contribuição de ${audiencia.HR_INICIO} h do dia ${audiencia.DT_INICIO_CONTRIBUICAO} até as ${audiencia.HR_FIM} h do dia ${audiencia.DT_FIM_CONTRIBUICAO}`}
            </Col>
          </Row>
        </div>
        <div className="quadro">
          <Row>
            <Col sm={12}>
              <h3>Objeto</h3>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              {audiencia.DS_AUDIENCIA}
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <h3>Documento Proposto</h3>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <>
                {arquivos
                  .filter(arq => {
                    return arq.ST_OBJETO === "S";
                  })
                  .map(arquivo => (
                    <a
                      href={arquivo.TipoLink === "A"? ender.file(arquivo.CA_ARQUIVO) : arquivo.CA_ARQUIVO }
                      key={arquivo.ID_ARQUIVO}
                      target="_blank" rel="noopener noreferrer"
                    >
                      {"» "}
                      {arquivo.DS_ARQUIVO}
                      <br />
                    </a>
                  ))}
              </>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <h3>Material de Apoio</h3>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <>
                {arquivos
                  .filter(arq => {
                    return (arq.ST_OBJETO === "N" || arq.ST_OBJETO === "1");
                  })
                  .map(arquivo => (
                    <a
                      href={arquivo.TipoLink === "A"? ender.file(arquivo.CA_ARQUIVO) : arquivo.CA_ARQUIVO }
                      key={arquivo.ID_ARQUIVO}
                      target="_blank" rel="noopener noreferrer"
                    >
                      {"» "}
                      {arquivo.DS_ARQUIVO}
                      <br />
                    </a>
                  ))}
              </>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <h3 className={
                  arquivos.filter(arqcont => {return arqcont.ST_OBJETO === "5" || arqcont.ST_OBJETO === "6"}).length === 0 &&
                  resultados.length === 0 
                  ? "naoMostrar" : ""}>Resultados</h3>
            </Col>
          </Row>
          <Row className={resultados.length === 0? "naoMostrar" : ""}>
            <Col sm={12}>
              <a href={`/Consulta/${idAudiencia}/Rac/`}>» RAC – Relatório de Avaliação das Contribuições Recebidas na Consulta Pública</a>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
                {arquivos
                  .filter(arq => {
                    return arq.ST_OBJETO === "5" || arq.ST_OBJETO === "6";
                  })
                  .map(arquivo => (
                    <a
                    href={arquivo.TipoLink === "A"? ender.file(arquivo.CA_ARQUIVO) : arquivo.CA_ARQUIVO }
                      key={arquivo.ID_ARQUIVO}
                      target="_blank" rel="noopener noreferrer"
                    >
                      {"» "}
                      {arquivo.DS_ARQUIVO}
                      <br />
                    </a>
                ))}
              </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <h3 className={estatisticas.length>0? "" : "naoMostrar"}>Estatísticas desta {audiencia.DS_MODALIDADE}</h3>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
                    Quantidade de contribuições recebidas: {estatisticas.length> 0 ? estatisticas[0].qtContribuicao : ""}
            </Col>
            <Col sm={6}>
                    Quantidade de participantes que fizeram contribuição: {estatisticas.length> 0 ? estatisticas[0].qtParticipante : ""}
            </Col>
          </Row>
        </div>
        <div>
          <Row>
            <Col sm={6} align="center">
              <button
                id="btnContribuir"
                type="submit"
                className={
                  (audiencia.ST_ENCERRADO !== "P") || (audiencia.ST_INTERNO === "S" && usuarioANA !== "S")
                    ? "btnConsulta contrib naoMostrar"
                    : "btnConsulta contrib"
                }
                onClick={() => handleClickContribuir(audiencia.ID_AUDIENCIA)}
              >
                {"Contribuir para esta "}
                {audiencia.DS_MODALIDADE}
              </button>
            </Col>
            <Col sm={6} align="center">
              <button
                type="submit"
                className={estatisticas.length > 0 && estatisticas[0].qtContribuicao > 0 ? "btnConsulta listaContrib" : "naoMostrar"}
                onClick={() =>
                  handleClickListarContribuicoes(audiencia.ID_AUDIENCIA)
                }
              >
                {"Veja as contribuições para esta "}
                {audiencia.DS_MODALIDADE}
              </button>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}
